// extracted by mini-css-extract-plugin
export var avatarContainer = "_ae-0";
export var avatarTypingWave = "_ae-i";
export var gray = "_ae-f";
export var green = "_ae-c";
export var icon = "_ae-9";
export var image = "_ae-1";
export var lg = "_ae-6";
export var md = "_ae-5";
export var presenceDot = "_ae-b";
export var red = "_ae-d";
export var sm = "_ae-4";
export var status = "_ae-a";
export var typingDot = "_ae-h";
export var typingPill = "_ae-g";
export var xl = "_ae-7";
export var xs = "_ae-3";
export var xxl = "_ae-8";
export var xxs = "_ae-2";
export var yellow = "_ae-e";